import request from '../utils/request'

// 手机号码注册
export function registerApi(data) {
  return request({
    url: '/other/register',
    method: 'post',
    data
  })
}
// 商家入驻
export function merchantSettlementApi(data) {
  return request({
    url: '/other/merchantSettlement',
    method: 'post',
    data
  })
}
// 商家支付入驻费
export function payMerchantSettlement(data) {
  return request({
    url: '/other/payMerchantSettlement/',
    method: 'post',
    data
  })
}
// 判断商家是否支付
export function searchOrderPay(orderNo) {
  return request({
    url: '/other/searchOrderPay/' + orderNo,
    method: 'post'
  })
}
// 将二维码地址转为流输出
export function outCodeUrl(data) {
  return request({
    url: '/other/outCodeUrl',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 邮箱登录
export function loginByEmailApi(data) {
  return request({
    url: '/other/loginByEmail',
    method: 'post',
    data
  })
}
// 发送邮箱验证码
export function getCode(email) {
  return request({
    url: '/other/getCode/' + email,
    method: 'post'
  })
}

// 邮箱注册
export function registerEmail(data) {
  return request({
    url: '/other/registerEmail',
    method: 'post',
    data
  })
}

// 获取谷歌授权地址
export function getGoogleLoginUrl() {
  return request({
    url: '/thirdParty/getGoogleLoginUrl',
    method: 'get'
  })
}

// 谷歌授权登录绑定邮箱获取邮箱验证码
export function sendBindGoogleEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindGoogleEmailCode/' + bindEmail,
    method: 'post'
  })
}

// 谷歌授权登录
export function googleLogin(data) {
  return request({
    url: '/thirdParty/googleLogin',
    method: 'post',
    data
  })
}

// 获取前台facebook的授权地址
export function getFacebookLoginUrl() {
  return request({
    url: '/thirdParty/getFacebookLoginUrl',
    method: 'get'
  })
}

// Facebook授权登录绑定邮箱获取邮箱验证码
export function sendBindFacebookEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindFacebookEmailCode/' + bindEmail,
    method: 'post'
  })
}

// Facebook授权登录
export function facebookLogin(data) {
  return request({
    url: '/thirdParty/facebookLogin',
    method: 'post',
    data
  })
}

// 获取前台Instagram的授权地址
export function getInstagramLoginUrl() {
  return request({
    url: '/thirdParty/getInstagramLoginUrl',
    method: 'get'
  })
}

// Instagram授权登录绑定邮箱获取邮箱验证码
export function sendBindInstagramEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindInstagramEmailCode/' + bindEmail,
    method: 'post'
  })
}

// Instagram授权登录
export function instagramLogin(data) {
  return request({
    url: '/thirdParty/instagramLogin',
    method: 'post',
    data
  })
}

// 获取前台Tiktok的授权地址
export function getTiktokLoginUrl() {
  return request({
    url: '/thirdParty/getTiktokLoginUrl',
    method: 'get'
  })
}

// Tiktok授权登录绑定邮箱获取邮箱验证码
export function sendBindTiktokEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindTiktokEmailCode/' + bindEmail,
    method: 'post'
  })
}

// Tiktok授权登录
export function tiktokLogin(data) {
  return request({
    url: '/thirdParty/tiktokLogin',
    method: 'post',
    data
  })
}

// 获取前台LinkedIn的授权地址
export function getLinkedInLoginUrl() {
  return request({
    url: '/thirdParty/getLinkedInLoginUrl',
    method: 'get'
  })
}

// LinkedIn授权登录绑定邮箱获取邮箱验证码
export function sendBindLinkedInEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindLinkedInEmailCode/' + bindEmail,
    method: 'post'
  })
}

// LinkedIn授权登录
export function linkedInLogin(data) {
  return request({
    url: '/thirdParty/linkedInLogin',
    method: 'post',
    data
  })
}

// 获取前台Twitter的授权地址
export function getTwitterLoginUrl() {
  return request({
    url: '/thirdParty/getTwitterLoginUrl',
    method: 'get'
  })
}

// Twitter授权登录绑定邮箱获取邮箱验证码
export function sendBindTwitterEmailCode(bindEmail) {
  return request({
    url: '/thirdParty/sendBindTwitterEmailCode/' + bindEmail,
    method: 'post'
  })
}

// Twitter授权登录
export function twitterLogin(data) {
  return request({
    url: '/thirdParty/twitterLogin',
    method: 'post',
    data
  })
}

// 获取客服联系二维码
export function getCodeImage(data) {
  return request({
    url: '/other/getCodeImage',
    method: 'post',
    data
  })
}

// 获取客服联系二维码
export function getContactEmail(data) {
  return request({
    url: '/other/getContactEmail',
    method: 'post',
    data
  })
}